import { gql } from '@apollo/client';
import { BLOCK_SETTINGS_FIELD, MEDIA_FIELD } from '../../fields';

export const STICKY_IMAGE_SCROLL = gql`
  fragment StickyImageScrollBlockFragment on StickyImageScroll {
    blockSettings {
      ...BlockSettingsFieldFragment
    }
    image {
      ...MediaFieldFragment
    }
    items {
      content
      showImageNode
      imageNode {
        x
        y
        icon
      }
    }
    id
    blockName
    blockType
  }
  ${MEDIA_FIELD}
  ${BLOCK_SETTINGS_FIELD}
`;
